/**
 * Testimonials video slider — mobile: 1 reel per slide; desktop: N reels per viewport (default 4), paged.
 * Video: custom play overlay until play; then inline playback + native controls (fullscreen optional via browser).
 */
(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function init(root) {
    if (!root || root.getAttribute('data-tvs-init') === 'true') return;
    root.setAttribute('data-tvs-init', 'true');

    var viewport = qs(root, '.tvs__viewport');
    var track = qs(root, '.tvs__track');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tvs-slide]'));
    if (!cards.length) return;

    var slideIndex = 0;
    var pageIndex = 0;

    var navPrev = qs(root, '[data-tvs-prev]');
    var navNext = qs(root, '[data-tvs-next]');
    var dotsContainer = qs(root, '[data-tvs-dots]');
    var sliderUi = qs(root, '[data-tvs-slider-ui]');

    var mqMobile = window.matchMedia('(max-width: 767px)');

    function getGap() {
      return parseInt(root.getAttribute('data-tvs-gap') || '16', 10);
    }

    function getDesktopPerView() {
      var v = parseInt(root.getAttribute('data-tvs-desktop-per-page') || '4', 10);
      return v > 0 ? v : 4;
    }

    function isMobile() {
      return mqMobile.matches;
    }

    function desktopMaxPage() {
      var per = getDesktopPerView();
      return Math.max(0, Math.ceil(cards.length / per) - 1);
    }

    function shouldShowNav() {
      if (cards.length <= 1) return false;
      if (isMobile()) return true;
      return desktopMaxPage() > 0;
    }

    function layoutTrack() {
      var W = viewport.offsetWidth;
      var G = getGap();
      var n = cards.length;

      if (isMobile()) {
        track.style.gap = '0px';
        cards.forEach(function (c) {
          c.style.width = W + 'px';
          c.style.flexBasis = W + 'px';
          c.style.minWidth = W + 'px';
        });
        track.style.width = W * n + 'px';
        track.style.transform = 'translateX(' + -slideIndex * W + 'px)';
        root.setAttribute('data-tvs-layout', 'mobile');
        return;
      }

      var per = getDesktopPerView();
      var cw = (W - (per - 1) * G) / per;
      track.style.gap = G + 'px';
      cards.forEach(function (c) {
        c.style.width = cw + 'px';
        c.style.flexBasis = cw + 'px';
        c.style.minWidth = cw + 'px';
      });
      var trackW = n * cw + (n - 1) * G;
      track.style.width = trackW + 'px';

      var maxP = desktopMaxPage();
      pageIndex = Math.min(pageIndex, maxP);

      var offset = pageIndex * W;
      var maxOffset = Math.max(0, trackW - W);
      offset = Math.min(offset, maxOffset);
      track.style.transform = 'translateX(' + -offset + 'px)';
      root.setAttribute('data-tvs-layout', 'desktop');
    }

    function updateDots() {
      if (!dotsContainer) return;
      if (!isMobile()) {
        dotsContainer.innerHTML = '';
        return;
      }
      dotsContainer.innerHTML = '';
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tvs__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === slideIndex) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          slideIndex = i;
          layoutTrack();
          updateDots();
          updateNavDisabled();
        });
        dotsContainer.appendChild(b);
      });
    }

    function updateNavDisabled() {
      if (isMobile()) {
        if (navPrev) navPrev.disabled = slideIndex <= 0;
        if (navNext) navNext.disabled = slideIndex >= cards.length - 1;
      } else {
        if (navPrev) navPrev.disabled = pageIndex <= 0;
        if (navNext) navNext.disabled = pageIndex >= desktopMaxPage();
      }
    }

    function go(delta) {
      if (isMobile()) {
        slideIndex = Math.max(0, Math.min(cards.length - 1, slideIndex + delta));
      } else {
        pageIndex = Math.max(0, Math.min(desktopMaxPage(), pageIndex + delta));
      }
      layoutTrack();
      updateDots();
      updateNavDisabled();
    }

    function refresh() {
      slideIndex = Math.min(slideIndex, Math.max(0, cards.length - 1));
      pageIndex = Math.min(pageIndex, desktopMaxPage());
      layoutTrack();
      if (sliderUi) {
        sliderUi.style.display = shouldShowNav() ? '' : 'none';
      }
      updateDots();
      updateNavDisabled();
    }

    if (navPrev) navPrev.addEventListener('click', function () { go(-1); });
    if (navNext) navNext.addEventListener('click', function () { go(1); });

    var ro = new ResizeObserver(function () {
      layoutTrack();
    });
    ro.observe(viewport);

    mqMobile.addEventListener('change', function () {
      slideIndex = 0;
      pageIndex = 0;
      refresh();
    });

    window.addEventListener(
      'resize',
      function () {
        layoutTrack();
      },
      { passive: true }
    );

    function setPlayingUi(wrap, playBtn, playing) {
      if (playing) {
        if (playBtn) playBtn.setAttribute('hidden', 'hidden');
        if (wrap) wrap.classList.add('tvs__media--playing');
      } else {
        if (playBtn) playBtn.removeAttribute('hidden');
        if (wrap) wrap.classList.remove('tvs__media--playing');
      }
    }

    cards.forEach(function (card) {
      var media = qs(card, '.tvs__media');
      var video = qs(card, 'video');
      var playBtn = qs(card, '.tvs__play');
      if (!video || !playBtn || !media) return;

      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      function enableControls() {
        video.controls = true;
        video.setAttribute('controls', 'controls');
      }

      function disableControls() {
        video.controls = false;
        video.removeAttribute('controls');
      }

      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = false;
        enableControls();
        setPlayingUi(media, playBtn, true);
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.catch(function () {
            setPlayingUi(media, playBtn, false);
            disableControls();
            video.muted = true;
          });
        }
      });

      video.addEventListener('play', function () {
        enableControls();
        setPlayingUi(media, playBtn, true);
      });

      video.addEventListener('pause', function () {
        if (video.ended) return;
        /* Keep controls + inline playback; overlay stays hidden so native UI works */
        enableControls();
      });

      video.addEventListener('ended', function () {
        disableControls();
        video.muted = true;
        video.currentTime = 0;
        setPlayingUi(media, playBtn, false);
      });
    });

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-tvs-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    ev.target.querySelectorAll('[data-tvs-root]').forEach(function (el) {
      el.removeAttribute('data-tvs-init');
      init(el);
    });
  });
})();
